import React, { useEffect, useRef, useState } from 'react';
import '../../../Static/priceinfo.css';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material'; 
import { selectKajeRegister } from '../../Selectors/StitchSelector/StitchingSelectors';
import { fetchKajeRegister } from '../../../Store/PHPSlice/Kaje/KajeApi';

const KajeInfo = () => {
    const [formData, setFormData] = useState({
        dt: '',
        ordType:'',
        kjMemo: '',
        sreMemo: '',
        empNm: '',
        itemNm: '',
        sono: '',
        soId: '',
        mcloth: '',
        mclothNm: '',
        m1cloth: '',
        m1clothNm: '',
        m2cloth: '',
        m2clothNm: '',
        m3cloth: '',
        m3clothNm: '',
        totQty: '',
        instruction: ''
    });
    const { Id } = useParams();
    const dispatch = useDispatch();
    const kajelist = useSelector(selectKajeRegister);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const componentRef = useRef(); // Ref for the component to be printed
    useEffect(() => {
        dispatch(fetchKajeRegister(Id))
    }, [Id, dispatch]);
    useEffect(() => {
        if (kajelist.data && kajelist.data.length > 0) {
            const item = kajelist.data[0];
            setFormData(prev => ({
                ...prev,
                dt: item.dt,
                ordType:item.ordType,
                kjMemo: item.kjMemo,
                sreMemo: item.sreMemo,
                totQty: item.totQty,
                instruction: item.instruction,
                empNm: item.empNm,
                itemNm: item.itemNm,
                soId: item.soId,
                sono: item.sono,
                mcloth: item.mcloth || '',
                mclothNm: item.mclothNm || '',
                m1cloth: item.m1cloth || '',
                m1clothNm: item.m1clothNm || '',
                m2cloth: item.m2cloth || '',
                m2clothNm: item.m2clothNm || '',
                m3cloth: item.m3cloth || '',
                m3clothNm: item.m3clothNm || '',
            }));
        }
    }, [kajelist]);


    const tableContainerStyle = {
        marginLeft: isDesktop ? '5%' : '0%',
        width: isDesktop ? '90%' : '100%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none'
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',  // Ensure the x-axis scrollbar is visible
        overflowY: 'hidden', // Hide the y-axis scrollbar
        WebkitOverflowScrolling: 'touch', // Enable smooth scrolling on iOS
    };
    // var itemData = kajelist.Info.length > 0 ? {
    //     size: kajelist.Info.map(val => val.size),
    //     sreqty: kajelist.Info.map(val => parseFloat(val.sreqty)),
    //     issqty: kajelist.Info.map(val => parseFloat(val.issqty)),
    //     balqty: kajelist.Info.map(val => parseFloat(val.balqty)),
    // } : [];
    const itemData = kajelist?.Info?.length > 0
    ? {
        size: kajelist.Info.map(val => val.size),
        sreqty: kajelist.Info.map(val => parseFloat(val.sreqty)),
        issqty: kajelist.Info.map(val => parseFloat(val.issqty)),
        balqty: kajelist.Info.map(val => parseFloat(val.balqty)),
    }
    : {
        size: [],
        sreqty: [],
        issqty: [],
        balqty: [],
    };


    return (
        <>
            <Grid item xs={12}>
                <Paper style={{ padding: '3vh', margin: '0' }}>
                    <div style={{ margin: '5% 0%', width: '100%' }} ref={componentRef}>

                        <h3 className='centered-heading'>Kaje Info</h3>
                        <div className="dashed-line"></div>

                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '200px' }}>Date</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.dt}</td>

                                    <td style={{ width: '200px' }}>Order Type</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.ordType}</td>

                                </tr>

                                <tr>
                                    <td style={{ width: '200px' }}>Kaje Memo No.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.kjMemo}</td>

                                    <td style={{ width: '200px' }}>Stitching Return Memo No.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.sreMemo}</td>

                                </tr>

                                {formData.soId !== '0' &&

                                    <tr>
                                        <td style={{ width: '200px' }}>Sale Order No.</td>
                                        <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.sono}</td>

                                    </tr>
                                }
                                <tr>
                                    <td style={{ width: '200px' }}>Master</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.empNm}</td>
                                    <td style={{ width: '200px' }}>Item</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.itemNm}</td>


                                </tr>
                                <tr>
                                    <td style={{ width: '200px' }}>Issue Qty.</td>
                                    <td style={{ width: '30vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.totQty}</td>
                                </tr>

                            </tbody>
                        </table>
                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>

                            <tbody>


                                <tr>
                                    <td style={{ width: '100px' }}>Main Cloth</td>
                                    <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.mclothNm}</td>

                                </tr>

                                {formData.m1cloth !== '0' &&
                                    <tr>
                                        <td style={{ width: '100px' }}>Matching-1</td>
                                        <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m1clothNm}</td>
                                    </tr>
                                }

                                {formData.m2cloth !== '0' &&
                                    <tr>
                                        <td style={{ width: '100px' }}>Matching-2</td>
                                        <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m2clothNm}</td>
                                    </tr>
                                }

                                {formData.m3cloth !== '0' &&
                                    <tr>
                                        <td style={{ width: '100px' }}>Matching-3</td>
                                        <td style={{ width: '40vw', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.m3clothNm}</td>
                                    </tr>
                                }


                            </tbody>

                        </table>
                        <table style={{ margin: '1% 5%', fontSize: '14px' }}>

                            <tbody>
                                <tr>

                                    <td style={{ width: '200px' }}>Kaje Instructions</td>
                                    <td style={{ width: '800px', padding: ' 0.2%  1.5%' }} className='dark-color'>{formData.instruction}</td>

                                </tr>
                            </tbody>
                        </table>

                        <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Size</TableCell>
                                        {itemData.size ? itemData.size.map((val, index) => (
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val}</TableCell>
                                        )) : null}
                                    </TableRow>


                                    <TableRow>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Qty.</TableCell>
                                        {itemData.sreqty ? itemData.sreqty.map((val, index) => (
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val}</TableCell>
                                        )) : null}
                                    </TableRow>

                                    <TableRow>
                                        <TableCell sx={{ p: 1, border: '1px solid #000', width: '150px' }} align='center' className='tbl-row'>Issue Qty.</TableCell>
                                        {itemData.issqty ? itemData.issqty.map((val, index) => (
                                            <TableCell sx={{ p: 1, border: '1px solid #000' }} align='center' key={index}>{val}</TableCell>
                                        )) : null}
                                    </TableRow>

                                </TableBody>
                            </Table>
                        </TableContainer>

                    </div>
                    <div style={{ margin: '2% 5%', paddingBottom: '2%' }}>
                        <ReactToPrint
                            trigger={() => <Button variant="contained" color="primary">Print</Button>}
                            content={() => componentRef.current}
                        />
                    </div>
                </Paper>
            </Grid>
        </>
    );
};

export default KajeInfo;
